exports.components = {
  "component---src-pages-band-js": () => import("./../../../src/pages/band.js" /* webpackChunkName: "component---src-pages-band-js" */),
  "component---src-pages-dates-js": () => import("./../../../src/pages/dates.js" /* webpackChunkName: "component---src-pages-dates-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

